import { RouteComponentProps } from "react-router-dom"
import { useProjectDashboard } from "../../../projects/hooks/use-project-dashboard"
import ProjectDashboard from "../../../projects/components/ProjectDashboard"
import ErrorList from "../../../components/ErrorList"
import { useTranslation } from "react-i18next"
import { CircularProgress } from "@material-ui/core"

type RouteParams = { projectId: string }

const queryOptions = { refetchOnMountOrArgChange: true } as const

const ProjectDashboardRoute = ({ match }: RouteComponentProps<RouteParams>) => {
  const { t } = useTranslation()
  const {
    projectDashboard,
    isLoading: isLoadingDashboard,
    error: dashboardError,
  } = useProjectDashboard(match.params.projectId, queryOptions)

  if (isLoadingDashboard) return <CircularProgress />
  if (dashboardError) return <ErrorList errors={[t("fetchErrorProjectsDashboard")]} />
  if (!projectDashboard) return <ErrorList errors={[t("projectsDashboardNotFoundError")]} />

  return <ProjectDashboard projectDashboard={projectDashboard} />
}

export default ProjectDashboardRoute
